import ModalBase from "components/ModalBase/modal_base";
import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { Form, Formik } from "formik";
import React from "react";
import MDTypography from "components/MDTypography";
import { useCloseModal } from "hooks/useCloseModal";
import FormField from "components/FormField";
import { useCreateTagsMutation, useEditTagsMutation } from "services";
import { useDispatch } from "react-redux";
import { setNuevaCarpeta } from "slices";

const ModalCarpetaCursos = ({ open, handleClose, edit }) => {
  const dispatch = useDispatch();
  const [
    crearCarpeta,
    {
      isSuccess: isSuccessC,
      isError: isErrorC,
      isLoading: isLoadingC,
      error: errorC,
    },
  ] = useCreateTagsMutation();

  const [
    editarCarpeta,
    {
      isSuccess: isSuccessEdit,
      isError: isErrorEdit,
      isLoading: isLoadingEdit,
      error: errorEdit,
    },
  ] = useEditTagsMutation();

  const submitForm = async (values, actions) => {
    try {
      if (edit && edit.id) {
        // Si 'edit' tiene un ID, estamos editando
        await editarCarpeta({ id: edit.id, ...values }).unwrap();
      } else {
        // De lo contrario, estamos creando
        await crearCarpeta(values).unwrap();
        dispatch(setNuevaCarpeta(values.nombre));
      }
    } catch (error) {
      console.error("Error al guardar la carpeta:", error);
    }
  };

  const handleSubmit = (values, actions) => {
    submitForm(values, actions);
  };

  useCloseModal(
    edit ? isLoadingEdit : isLoadingC,
    edit ? isSuccessEdit : isSuccessC,
    edit ? isErrorEdit : isErrorC,
    edit ? errorEdit : errorC,
    edit
      ? `Carpeta actualizada correctamente.`
      : `Nueva carpeta creada correctamente.`,
    handleClose
  );
  const initialNombre = edit && edit.nombre ? edit.nombre : "";

  return (
    <ModalBase open={open} handleClose={handleClose}>
      <MDBox>
        <Formik
          initialValues={{ nombre: initialNombre }}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({ values, isSubmitting }) => {
            const currentIsLoading = edit ? isLoadingEdit : isLoadingC;
            return (
              <Form>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={12}>
                    <MDTypography variant="h5" fontWeight="medium" mb={1}>
                      {edit
                        ? "Editar nombre de la carpeta:"
                        : "Nombre de la carpeta que desea crear:"}
                    </MDTypography>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <FormField
                      label={"Nombre"}
                      name={"nombre"}
                      value={values.nombre}
                      onInput={(e) =>
                        (e.target.value = ("" + e.target.value).toUpperCase())
                      }
                    />
                  </Grid>

                  <Grid item xs={12} sm={12}>
                    <MDBox
                      display="flex"
                      flexDirection="row"
                      justifyContent="space-between"
                      mt={3}
                    >
                      <MDButton
                        variant="gradient"
                        color="dark"
                        size="medium"
                        onClick={handleClose}
                        disabled={currentIsLoading}
                      >
                        cancelar
                      </MDButton>

                      <MDButton
                        variant="gradient"
                        size="medium"
                        type="submit"
                        color="light"
                        disabled={currentIsLoading}
                      >
                        {edit ? "Guardar Cambios" : "Aceptar"}
                      </MDButton>
                    </MDBox>
                  </Grid>
                </Grid>
              </Form>
            );
          }}
        </Formik>
      </MDBox>
    </ModalBase>
  );
};

export default ModalCarpetaCursos;
